export default {
  searchedTweetEntities(state) {
    return state.searchedTweetEntities;
  },
  searchFeedAccounts(state) {
    return state.searchFeedAccounts;
  },
  searchFeed(state) {
    return state.searchFeed;
  },
  searchFeedAccountsForSelect(state) {    
    return state.searchFeedAccounts.map((feeder) => ({
      id: feeder.value,
      text: feeder.name,
      sourceid: Number(feeder.externalKey)
    }));
  },
};
